import { jsx as _jsx } from "react/jsx-runtime";
import { CsgPrimitive } from '../CsgPrimitive';
export function CSGBox3D({ node, children }) {
    return (_jsx(CsgPrimitive, { node: node, properties: node.properties, children: children }));
}
//# sourceMappingURL=Component.js.map